import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { useAppStore } from 'stores/appStore';
import { categories } from 'config/categories';
import { getCategoriesForCurrentProvider } from 'config/providers';
import styles from './CategoryGrid.scss';
import { SelectionCard } from '@wix/gg-common-lib/components';

export function CategoryGrid() {
  const { t } = useTranslation();

  const selectedCategory = useAppStore((state) => state.selectedCategory);
  const setSelectedCategory = useAppStore((state) => state.setSelectedCategory);

  const categoryKeys = getCategoriesForCurrentProvider();

  return (
    <div className={styles.categoryGrid}>
      {categoryKeys.map((categoryKey) => {
        const category = categories[categoryKey];
        return (
          <SelectionCard
            key={categoryKey}
            title={t(category.i18nKey)}
            icon={<category.Icon size={20} color={category.color} />}
            onClick={() => setSelectedCategory(categoryKey)}
            isSelected={selectedCategory === categoryKey}
          />
        );
      })}
    </div>
  );
}
